import { FULL_EMAIL_REGEX } from './emailRegex'

export const checkFullEmail = async (value: string): Promise<string> => {
  const regexp = new RegExp(FULL_EMAIL_REGEX)

  return regexp.test(value) ? '' : 'Please, enter a correct email'
}

export const checkString = async (
  value: string,
  errStr: string = "The value shouldn't be empty"
): Promise<string> => {
  return value.length > 0 ? '' : errStr
}

/* `spJBPCommitmentDataApplyChanges` reads `$.Role` as `varchar(50)` and cuts anything longer. */
export const SIGNER_POST_MAX_LENGTH = 50

export const checkSignerPost = async (value: string): Promise<string> => {
  return value.trim().length <= SIGNER_POST_MAX_LENGTH
    ? ''
    : `Post should be ${SIGNER_POST_MAX_LENGTH} characters or fewer`
}
